import {
  Alert as _Alert,
  UncontrolledAlert as _UncontrolledAlert,
  AlertProps as _AlertProps,
  UncontrolledAlertProps as _UncontrolledAlertProps
} from "reactstrap";

export const Alert = _Alert;
export const UncontrolledAlert = _UncontrolledAlert;

export type AlertProps = _AlertProps;
export type UncontrolledAlertProps = _UncontrolledAlertProps;
